import React from "react";
import MainTable from '../../Components/Tables/Main/MainTable'
import {useAdministrators} from "../../Hooks/useAdministrators";
import AddBox from '@material-ui/icons/AddBox';

const Administrators = (props) => {
    const [administratorsData,addAdministrator, updateAdministrator , disableAdministrator, enableAdministrator] = useAdministrators();

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Nombre", field: "name" },
        {
          title: "Contraseña",
          field: "password",
          emptyValue: "************",
          editable: "onAdd",
        },
        { title: "Email", field: "email" },
        { title: "Activo", field: "active", lookup: {true: "Sí", false: "No"}, editable: "never"}
    ];

    const actions = [
        rowData => ({
          icon: AddBox,
          tooltip: 'Activar',
          onClick: (event, rowData) => enableAdministrator(rowData),
          disabled: rowData.active
        })
      ]

    const editRequiredFiles = ["name", "email"];

    return <MainTable 
            {...{ editRequiredFiles }}
            title="Administradores"
            columns={columns}
            actions={actions}
            data={administratorsData}
            requiredFields={[...editRequiredFiles, "password"]}
            deleteText="Podrá ser reactivado luego"
            onRowAdd={addAdministrator}
            onRowUpdate={updateAdministrator}
            onRowDelete={disableAdministrator}
            isDeletable={(row) => row.active}
            />
}

export default Administrators


// WEBPACK FOOTER //
// ./src/Containers/Administrators/Administrators.js